const BANNED_PROPS = ['id'];
export { BANNED_PROPS };
